import React, { useEffect, useState } from 'react'

const ratingArray = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
]

export const FormRating = props => {
  const { classes } = props
  const [rating, setRating] = useState(0)

  const onChangeRating = e => {
    props.setIsError(false)
    e.target.value && setRating(+e.target.value)
  }

  useEffect(() => {
    props.handleChange('score', rating)
  }, [rating])

  return (
    <div onClick={onChangeRating} className={classes.container}>
      {ratingArray.map(item => (
        <label htmlFor={`rating-${item.value}`} key={item.value}>
          <input
            id={`rating-${item.value}`}
            type="radio"
            name="rating"
            value={item.value}
          />
          <p
            className={`${classes.inputLabel} ${
              item.value <= rating && classes.activeInputLabel
            } ${props.isError && classes.isError}`}>
            {item.label}
          </p>
        </label>
      ))}
    </div>
  )
}
